<!----
    Author: hjlee
    Description:
        가운데 이미지를 위치하고 상단 혹은 좌우를 잘라내는 이미지 컨트롤
---->
<template>
  <b-img-lazy
    v-if="lazy"
    :src="srcProcessed"
    :alt="alt"
    :thumbnail="thumbnail"
    :class="['centered-image', loaded?'loaded':'', move ? 'move' : '', dragging ? 'dragging' : '']"
    @load="onLoaded"
    @click="$emit('click', $event)"
    @mousedown="onDragStart($event)"
    @mouseup="onDragEnd($event)"
    @mousemove="onDragOver($event)"
    @mouseleave="onDragEnd($event)"
  />
  <b-img
    v-else
    :src="srcProcessed"
    :alt="alt"
    :thumbnail="thumbnail"
    :class="['centered-image', loaded?'loaded':'']"
    @load="onLoaded"
    @click="$emit('click', $event)"
  />
</template>

<script>
import loadImage from 'blueimp-load-image'
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    lazy: {
      type: Boolean,
      default: false
    },
    dragging: {
      type: Boolean,
      default: false
    },
    move: {
      type: Boolean,
      default: false
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    cover: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      loaded: false,
      srcProcessed: '/img/thumb/defaultPicture.png'
    }
  },
  watch: {
    src: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tryRecalculateLayout()
      }
    }
  },
  mounted() {
    $(window).bind('resize', this.tryRecalculateLayout)
  },
  beforeDestroy() {
    $(window).unbind('resize', this.tryRecalculateLayout)
  },
  methods: {
    onLoaded() {
      $(this.$el).fadeIn()
      this.tryRecalculateLayout()
    },
    tryRecalculateLayout() {
      this.orientationProcessed = false
      this.recalculateLayout()
    },
    recalculateLayout() {
      if (this.lastLoadedImage === this.src) {
        return
      }
      const src = this.src
      this.lastLoadedImage = src
      const self = this
      if (src.startsWith('data:') && !this.orientationProcessed) {
        this.orientationProcessed = true
        loadImage(
          src,
          function(img, data) {
            if (data && data.exif && data.exif[274]) {
              loadImage(
                src,
                function(result) {
                  if (result.type === 'error') {
                    console.error(result)
                  } else if (result instanceof HTMLCanvasElement) {
                    self.$nextTick(() => {
                      self.srcProcessed = result.toDataURL('image/jpg')
                      self.resizeLayout()
                    })
                  } else {
                    self.$nextTick(() => {
                      self.srcProcessed = result.src
                      self.resizeLayout()
                    })
                  }
                },
                {
                  orientation: data.exif[274]
                }
              )
            } else {
              self.srcProcessed = self.src
              self.resizeLayout()
            }
          },
          { meta: true }
        )
      } else {
        this.srcProcessed = this.src
        this.resizeLayout()
      }
    },
    resizeLayout() {
      this.frameWidth = $(this.$el)
        .parent()
        .width()
      this.frameHeight = $(this.$el)
        .parent()
        .height()
      this.img = new Image()
      const self = this

      this.img.onload = function() {
        self.imgWidth = this.width
        self.imgHeight = this.height
        self.marginTop = 0
        self.marginLeft = 0
        self.marginBottom = 0
        self.marginRight = 0
        if (
          self.frameWidth >= self.imgWidth &&
          self.frameHeight >= self.imgHeight
        ) {
          self.resizedImgWidth = self.imgWidth
          self.resizedImgHeight = self.imgHeight
        } else if (
          self.imgWidth / self.frameWidth >
          self.imgHeight / self.frameHeight
        ) {
          if (self.cover) {
            self.resizedImgHeight = self.frameHeight
            self.resizedImgWidth =
              (self.imgWidth * self.frameHeight) / self.imgHeight
          } else {
            self.resizedImgWidth = self.frameWidth
            self.resizedImgHeight =
              (self.imgHeight * self.frameWidth) / self.imgWidth
          }
        } else if (self.cover) {
          self.resizedImgWidth = self.frameWidth
          self.resizedImgHeight =
            (self.imgHeight * self.frameWidth) / self.imgWidth
        } else {
          self.resizedImgHeight = self.frameHeight
          self.resizedImgWidth =
            (self.imgWidth * self.frameHeight) / self.imgHeight
        }
        self.marginTop = (self.frameHeight - self.resizedImgHeight) / 2
        self.marginBottom = (self.frameHeight - self.resizedImgHeight) / 2
        self.marginLeft = (self.frameWidth - self.resizedImgWidth) / 2
        self.marginRight = (self.frameWidth - self.resizedImgWidth) / 2
        $(self.$el).width(self.resizedImgWidth)
        $(self.$el).height(self.resizedImgHeight)
        $(self.$el).css('margin-top', self.marginTop)
        $(self.$el).css('margin-left', self.marginLeft)
        $(self.$el).css('margin-bottom', self.marginBottom)
        $(self.$el).css('margin-right', self.marginRight)
        self.loaded = true
      }
      this.img.src = this.srcProcessed
    }
  }
}
</script>

<style scoped>
img {
  max-width: none !important;
}
.centered-image {
  display: none;
  opacity: 0;
  transition: all 0.4s;
}
.centered-image.loaded {
  opacity: 1;
}
</style>
